import Header from './Header'
// import Homepic from '../../../assets/fam_pic.png'
import Video from '../../../assets/dubai.mp4'
import { Link } from 'react-router-dom'


// export default function Hero() {
//   return (
//     <div className="bg-white">
//       <Header />
//       <div className="relative isolate w-full pt-32">
//           <div className='w-full'>
//             <img className='' src={Homepic} alt="" />
//           </div>
      
//         {/* <div
//           aria-hidden="true"
//           className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
//         >
//           <div
//             style={{ 
//               clipPath:
//                 'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
//             }}
//             className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#70EFFB] to-[#9050E1] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
//           />
//         </div>
//         <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
//           <div className="hidden sm:mb-8 sm:flex sm:justify-center">
//             <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
//               Announcing our next round of resources...{' '}
//               <a href="/services" className="font-semibold text-indigo-600">
//                 <span aria-hidden="true" className="absolute inset-0" />
//                 Read more <span aria-hidden="true">&rarr;</span>
//               </a>
//             </div>
//           </div>
//           <div className="text-center">
//             <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
//               Study better with Edumore!
//             </h1>
//             <p className="mt-6 text-lg leading-8 text-gray-600">
//               Edumore is an excellent platform where you can learn and become
//               your best as a student!
//             </p>
//             <div className="mt-10 flex items-center justify-center gap-x-6">
//               <a
//                 href="/register"
//                 className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
//               >
//                 Get started
//               </a>
//               <a
//                 href="/about"
//                 className="text-sm font-semibold leading-6 text-gray-900"
//               >
//                 Learn more <span aria-hidden="true">→</span>
//               </a>
//             </div>
//           </div>
//         </div>
//         <div
//           aria-hidden="true"
//           className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
//         >
//           <div
//             style={{
//               clipPath:
//                 'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
//             }}
//             className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
//           />
//         </div> */}

//         {/* The Vision, Mission and Goal Section */}
//       <div className='grid grid-cols-1 inline-flex items-baseline gap-8 md:flex md:justify-between relative w-full p-32'>
//         <div className='rounded-lg w-full bg-white'>
//           <h2 className='font-extrabold text-[#a51d22]'>VISION</h2>
//           <p>
//             To be the undisputed leader in our chosen areas of specialization: investment immigration, investment advisory, and insurance thereby creating better financial futures for our clients.
//           </p>
//         </div>
//         <div className='rounded-lg w-full bg-white'>
//           <h2 className='font-extrabold text-[#a51d22]'>MISION</h2>
//           <p>
//             To improve lives by protecting, growing, enhancing, and optimizing wealth.
//           </p>
//         </div>
//         <div className='rounded-lg w-full bg-white'>
//           <h2 className='font-extrabold text-[#a51d22]'>GOAL</h2>
//           <p>
//             To leverage our vast expertise and global network of professionals to provide bespoke solutions and end-to-end service delivery, empowering our clients to transcend borders – physically and financially.
//           </p>
//         </div>
//       </div>

//       {/* The Country Section */}
//       <div className='grid grid-cols-1 inline-flex items-baseline gap-8 md:flex md:justify-between relative w-full p-32'>
//         <div className='rounded-lg w-full bg-white'>
//           <div>
//             <img src="" alt="" />
//           </div>
//           <h3></h3>
//         </div>
//         <div className='rounded-lg w-full bg-white'>
//           <div>
//             <img src="" alt="" />
//           </div>
//           <h3></h3>
//         </div>
//         <div className='rounded-lg w-full bg-white'>
//           <div>
//             <img src="" alt="" />
//           </div>
//           <h3></h3>
//         </div>
//       </div>

//       </div>
//     </div>
//   )
// }

export default function Hero() {
  return (
    <section className="relative h-screen min-h-[620px] flex items-center justify-center overflow-hidden">
      <Header />
      {/* YouTube Background */}
      <div className="absolute inset-0 -z-10 scale-110 pointer-events-none">
        {/* <iframe
          className="absolute top-1/2 left-1/2 min-w-full min-h-full -translate-x-1/2 -translate-y-1/2"
          src="https://www.youtube.com/embed/XjSBsNBLG1c?autoplay=1&mute=1&loop=1&playlist=XjSBsNBLG1c&controls=0&showinfo=0&rel=0&modestbranding=1"
          allow="autoplay; encrypted-media"
          title="Dubai Skyline"
        /> */}
        <video
          src={Video}
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          style={{ filter: 'brightness(57%) contrast(1.2)' }}
        />

        {/* <iframe           className="absolute top-1/2 left-1/2 min-w-full min-h-full -translate-x-1/2 -translate-y-1/2"
 width="850" height="478" src="https://www.youtube.com/embed/nQmFpa3yxxg?autoplay=1&mute" title="Dubai&#39;s Insane $100B Future Megaprojects" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
      </div>
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#0B1F45]/60" />

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 max-w-4xl">
        <h1 className="text-5xl md:text-7xl font-bold leading-tight">
          Manage Relationships.
          <br />
          <span className="text-red-600">Drive Growth.</span>
          <br />
          <span className="text-white/80 italic font-normal">
            Preserve Legacies.
          </span>
        </h1>

        <p className="mt-8 text-white/70 text-lg max-w-2xl mx-auto">
          The Optiva CRM Portal is your unified command centre for client
          intelligence and pipeline management.
        </p>

        <div className="mt-10 flex justify-center gap-4 flex-wrap">
          <Link
            to="/login"
            className="bg-red-600 px-8 py-4 rounded shadow-xl hover:shadow-2xl hover:-translate-y-1 transition"
          >
            Access Dashboard
          </Link>

          <a
            href="#about"
            className="border border-white/40 px-8 py-4 rounded hover:bg-white/10 transition"
          >
            Learn More
          </a>
        </div>
      </div>
    </section>
  )
}
